<template>
    <div id="login"  @keyup.enter="login">
        <el-container class="content">
            <el-main >
                <p class="login-top-text">登录</p>
                <el-input 
                    debounce 
                    type="text" 
                    clearable 
                    v-model="account" 
                    placeholder="用户账号" 
                    maxlength="16"
                    minlength="4"
                    prefix-icon="iconfont icon-accountfilling"
                ></el-input>
                <el-input 
                    type="password" 
                    v-model="password" 
                    clearable
                    show-password
                    placeholder="密码" 
                    maxlength="16"
                    minlength="4"
                    prefix-icon="iconfont icon-mima"
                ></el-input>
                <el-button 
                    type="primary" 
                    class="submit"
                    @click="login"
                    v-focus
                    v-loading.fullscreen.lock="loading"
                    element-loading-text="登录中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >登 录</el-button>
                <div id="div-img2">
                    <span class="passWd">
                        记住密码 :
                        <el-radio-group v-model="radio">
                            <el-radio label="1"  class="radioBtn">是</el-radio>
                            <el-radio label="0" class="radioBtn radioBtn1">否</el-radio>
                        </el-radio-group>
                    </span>
                    <img src="../../public/images/a.png" alt="" class="img2">
                </div>
                 <div id="div-img3">
                     <img src="../../public/images/logo.png" alt="" class="img3">
                 </div>
            </el-main>
        </el-container>
    </div>
</template>
<style lang="less" scoped> 
    #login{
        background: url('../../public/images/bg.jpg') no-repeat 100%;
        background-size: cover;
        .content{
            position: absolute;
            top: 50%;
            left: 50%;
            padding:40px 20px;
            background-color: rgba(16, 15, 10, 0.6);
            transform: translate(-50%,-50%);
            width:400px;
            .login-top-text{
                color: #fff;
                font-size: 24px;
                margin: 0 auto 20px;
                text-align: center;
            }
            .img2{
                width: 100%;
                margin-top: 10px;
            }
            #div-img2{
                margin-top: 10px;
                .passWd{
                    color: #cebaa5;
                }
                .radioBtn{
                    color: #cebaa5;
                }
                .radioBtn1{
                    margin-left: 20px !important;
                }

            }
            #div-img3{
                text-align: center;
                .img3{
                    width:50%;
                }
            }
            .reMember{
                margin-top: 20px;
            }

            .el-input{
                margin-bottom:20px;
            }
            .el-button{
                width:100%;
                margin-left: 0px;
            }
            .submit{
                background: #c5a166;
                border: none;
                 &:hover{
                    background: #d8b171;
                }
            }
        }
    }
</style>
<script>
import requestMixin from '../mixins/request'
// import { setSessionData } from '../env/util'  //!!!!储存数据

export default {
    mixins : [requestMixin],
    data(){
        return {
            account : '',
            password : '',
            radio: '0',
        }
    },
    mounted(){
        let orderHeight = document.documentElement.clientHeight;
        document.getElementById('login').style.height = orderHeight+'px'
        //判断sessionStorage
        this.getSession();
    },
    watch:{
       account: {
            deep: true,
            handler: function (newVal,oldVal){
                newVal && (newVal = newVal.toUpperCase())
                this.account = newVal ;
            }
       }
    },
    methods:{
        login(){
            let res = this.verifyLogin();
            if( res == false) return;
            this.checkLogin( this.account.trim(), this.password.trim(),this.radio);
        },
        verifyLogin(){
            if(this.account == '' || this.password == ''){
                this.alert('用户账号或密码为空', 'warning')
                return false ;
            }
        },
        //获取session中的缓存
        getSession(){
            let that = this;
            let userId = localStorage.getItem('account');
            let passWd = localStorage.getItem('passWd') ;
            that.account = userId ;
            function getPass(){
                that.password = passWd ;
                that.radio = '1'
            }
            passWd ? getPass() :  that.password = '' ;
        }
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    }
}
</script>
